export const EXCLUDED_SPECS = [
    'thml_cap',
    'pwr_cap',
    'pstate_cap',
    'cpu_prochot',
]
